import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CampaignViewProps } from "./campaign-view-props";
import {
  CustomTabPanelComponent,
  AlertComponent,
  BreadcrumbComponent,
} from "../../../common/components";
import CampaignViewDetailsViewPrimaryInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-primary-info/campaign-view-details-view-primary-info";
import CampaignViewDetailsAllTabs from "./campiagn-view-all-tabs";
import "./campaign-view.scss";
import { getCampaignDetails } from "../../../api/campaign";
import ViewTask from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/view-task/view-task";
import MODULES from "../../../constants/modules";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import ViewMeeting from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/view-meeting/view-meeting";
import ViewCall from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/view-call/view-call";
import { useMediaQuery } from "@mui/material";
import CampaignsViewDetailsAllTabsResponsive from "./campaign-view-details-all-tabs-responsive";
import { routes } from "../../../constants/routes";
import { Box } from "@mui/material";
import { breadcrumbLink } from "../campaign-list/campaign.constant";

const CampaignView: React.FC<CampaignViewProps> = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    selectedCampaignId: selectedCampaignIdProp,
    setLoading: setLoadingProp,
    // setViewTaskvalue,
    // viewTaskvalue = false,
    setCrumbMappingOption = () => {},
    // setViewMeetingvalue,
    // viewMeetingvalue = false,
    onCampaignNameUpdate,
    // viewCallValue = false,
    // setViewCallValue,
  } = props;

  // Prefer prop, fallback to location.state
  const selectedCampaignId =
    selectedCampaignIdProp || location.state?.selectedCampaignId;
  const { breadCrumb, campaignName } = location.state || {};
  // Provide fallback for setLoading
  const [internalLoading, internalSetLoading] = useState(false);
  const setLoading = setLoadingProp || internalSetLoading;
  const { canWrite, canDelete, canRead } = useResourcePermissions(
    MODULES.VIEW_CAMPAIGNS,
  );

  const isMobile = useMediaQuery("(max-width:768px)");

  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [viewEditOpen, setViewEditOpen] = useState<boolean>(false);
  const [campaignDetails, setCampaignDetails] = useState<any>(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [viewPrimaryInfoOpen, setViewPrimaryInfoOpen] =
    useState<boolean>(false);
  const [uploadedImage, setUploadedImage] = useState("");
  const [uploadedImageFile, setUploadedImageFile] = useState<File | null>(null);
  const [viewFullInfoOpen, setViewFullInfoOpen] = useState<boolean>(false);
  const [viewAddFullInfoOpen, setViewAddFullInfoOpen] =
    useState<boolean>(false);
  const [removeImage, setRemoveImage] = useState(false);
  const [breadcrumbMapping, setBreadcrumbMapping] =
    useState<any>(breadcrumbLink);
  // Task
  const [internalViewTask, setInternalViewTask] = useState<{
    open: boolean;
    taskId: number | null;
  }>({
    open: false,
    taskId: null,
  });
  const viewTaskvalue = props.viewTaskvalue || internalViewTask;
  const setViewTaskvalue = props.setViewTaskvalue || setInternalViewTask;

  // Meeting
  const [internalViewMeeting, setInternalViewMeeting] = useState<{
    open: boolean;
    meetingId: number | null;
  }>({
    open: false,
    meetingId: null,
  });
  const viewMeetingvalue = props.viewMeetingvalue || internalViewMeeting;
  const setViewMeetingvalue =
    props.setViewMeetingvalue || setInternalViewMeeting;

  // Call
  const [internalViewCall, setInternalViewCall] = useState<{
    open: boolean;
    callId: number | null;
  }>({
    open: false,
    callId: null,
  });
  const viewCallValue = props.viewCallValue || internalViewCall;
  const setViewCallValue = props.setViewCallValue || setInternalViewCall;

  const resetImageUpload = () => {
    setUploadedImage(campaignDetails?.campaign_profile_file_Url || "");
    setUploadedImageFile(null);
    setRemoveImage(false);
  };

  const fetchCampaignDetails = async () => {
    setLoading(true);
    try {
      const response = await getCampaignDetails(selectedCampaignId);
      setCampaignDetails(response.data.data);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while fetching the campaign.",
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchCampaignDetails();
  }, [selectedCampaignId]);

  const handleEditOpen = () => {
    setViewEditOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  useEffect(() => {
    if (breadCrumb) {
      const customMapping = [
        {
          label: "Campaigns",
          link: routes.CAMPAIGNLIST,
          handleClick: (event: any) => {
            event.preventDefault();
            setCrumbMappingOption(breadcrumbLink);
            setViewOpen(false);
            navigate(routes.CAMPAIGNLIST);
          },
        },
        {
          label: "View Campaigns",
          link: routes.CAMPAIGNLIST,
          handleClick: (event: any) => {
            event.preventDefault();
            setCrumbMappingOption(breadcrumbLink);
            setViewOpen(false);
            navigate(routes.CAMPAIGNLIST);
          },
        },
        { label: campaignName, link: "" },
      ];
      setBreadcrumbMapping(customMapping);
      setCrumbMappingOption();
    }
  }, [breadCrumb, campaignName]);
  return (
    <>
      {breadCrumb && (
        <Box className="breadcrumb-wrapper">
          <BreadcrumbComponent
            breadcrumbLink={breadcrumbMapping}
            showBackArrow
            handleBackArrowClick={() => navigate(routes.CAMPAIGNLIST)}
          />
        </Box>
      )}
      <div className="campaign-list-view">
        <div
          style={{
            display:
              !viewTaskvalue.open &&
              !viewMeetingvalue.open &&
              !viewCallValue.open
                ? "block"
                : "none",
          }}
        >
          <CustomTabPanelComponent value={0} index={0}>
            <CampaignViewDetailsViewPrimaryInfo
              campaignDetails={campaignDetails}
              viewPrimaryInfoOpen={viewPrimaryInfoOpen}
              setViewPrimaryInfoOpen={setViewPrimaryInfoOpen}
              viewFullInfoOpen={viewFullInfoOpen}
              uploadedImage={uploadedImage}
              setUploadedImage={setUploadedImage}
              setUploadedImageFile={setUploadedImageFile}
              setRemoveImage={setRemoveImage}
            />
          </CustomTabPanelComponent>
          {isMobile ? (
            <CampaignsViewDetailsAllTabsResponsive
              campaignDetails={campaignDetails}
              selectedCampaignId={selectedCampaignId}
              setLoading={setLoading}
              viewFullInfoOpen={viewFullInfoOpen}
              setViewFullInfoOpen={setViewFullInfoOpen}
              viewAddFullInfoOpen={viewAddFullInfoOpen}
              setViewAddFullInfoOpen={setViewAddFullInfoOpen}
              uploadedImage={uploadedImage}
              setUploadedImage={setUploadedImage}
              uploadedImageFile={uploadedImageFile}
              setUploadedImageFile={setUploadedImageFile}
              setRemoveImage={setRemoveImage}
              removeImage={removeImage}
              fetchCampaignDetails={fetchCampaignDetails}
              onCampaignNameUpdate={onCampaignNameUpdate}
              campaignId={selectedCampaignId}
              resetImageUpload={resetImageUpload}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              setViewTaskvalue={setViewTaskvalue}
              setCrumbMappingOption={
                breadCrumb ? setBreadcrumbMapping : setCrumbMappingOption
              }
              permissions={{
                canWrite,
                canDelete,
                canRead,
              }}
              setViewMeetingvalue={setViewMeetingvalue}
              viewCallValue={viewCallValue}
              setViewCallValue={setViewCallValue}
            />
          ) : (
            <CampaignViewDetailsAllTabs
              campaignDetails={campaignDetails}
              selectedCampaignId={selectedCampaignId}
              setLoading={setLoading}
              viewFullInfoOpen={viewFullInfoOpen}
              setViewFullInfoOpen={setViewFullInfoOpen}
              viewAddFullInfoOpen={viewAddFullInfoOpen}
              setViewAddFullInfoOpen={setViewAddFullInfoOpen}
              uploadedImage={uploadedImage}
              setUploadedImage={setUploadedImage}
              uploadedImageFile={uploadedImageFile}
              setUploadedImageFile={setUploadedImageFile}
              setRemoveImage={setRemoveImage}
              removeImage={removeImage}
              fetchCampaignDetails={fetchCampaignDetails}
              onCampaignNameUpdate={onCampaignNameUpdate}
              campaignId={selectedCampaignId}
              resetImageUpload={resetImageUpload}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              setViewTaskvalue={setViewTaskvalue}
              setCrumbMappingOption={
                breadCrumb ? setBreadcrumbMapping : setCrumbMappingOption
              }
              permissions={{
                canWrite,
                canDelete,
                canRead,
              }}
              setViewMeetingvalue={setViewMeetingvalue}
              viewCallValue={viewCallValue}
              setViewCallValue={setViewCallValue}
            />
          )}

          <AlertComponent
            message={alertMessage}
            type={alertType}
            open={alertOpen}
            onClose={handleAlertClose}
          />
        </div>
        {!viewTaskvalue.open ? (
          ""
        ) : (
          <ViewTask
            taskId={viewTaskvalue?.taskId}
            campaignDetails={campaignDetails}
          />
        )}
        {!viewMeetingvalue.open ? (
          ""
        ) : (
          <ViewMeeting
            meetingId={viewMeetingvalue?.meetingId}
            campaignDetails={campaignDetails}
          />
        )}
        {!viewCallValue.open ? (
          ""
        ) : (
          <ViewCall
            callId={viewCallValue?.callId}
            campaignDetails={campaignDetails}
          />
        )}
      </div>
    </>
  );
};

export default CampaignView;
